import { render, staticRenderFns } from "./deviceInactive.vue?vue&type=template&id=9d24878a&scoped=true&"
import script from "./deviceInactive.vue?vue&type=script&lang=js&"
export * from "./deviceInactive.vue?vue&type=script&lang=js&"
import style0 from "./deviceInactive.vue?vue&type=style&index=0&id=9d24878a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d24878a",
  null
  
)

export default component.exports